export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9864.527fde55.jpg";